module.exports = __webpack_public_path__ + "static/media/copy-icon.8a7764b0.svg";